package com.devi3east.bashbuddy.purchase.requests

import kotlinx.serialization.Serializable

@Serializable
data class UpdateAllocationsRequest(
    val ticketId: String,
    val updates: Map<String, List<String>>
)